import React, { useEffect, useState } from 'react';
import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';
import DealerService from 'services/DealerService';
import { JsonLink } from './JsonLink';
import './LendingSupport.scss';

interface Props {
  dealerId?: string | null;
  onClick: (dealer?: Dealer) => void;
  onError: (message: string) => void;
}

export const LendingSupportDealer: React.FC<Props> = ({
  dealerId,
  onClick,
  onError,
}) => {
  const [dealer, setDealer] = useState<Dealer | undefined>();

  useEffect(() => {
    setDealer(undefined);
    if (!dealerId) {
      return;
    }
    DealerService.getDealer(dealerId)
      .then((dealerObj) => {
        setDealer(dealerObj);
      })
      .catch(() => {
        onError('Unable to fetch dealer');
      });
  }, [dealerId]);

  return (
    <>
      <div>Dealer:</div>
      <JsonLink
        data={dealer}
        dataTestId={`dealer-link-${dealerId}`}
        onClick={() => onClick(dealer)}
        text={dealer?.name ?? undefined}
      />
    </>
  );
};
